module.exports = __webpack_public_path__ + "static/media/mini-set.b5b451c5.png";